export default{
    data() {
        return {
            blockScroll: false,
            nowThrottle: new Date().getTime()
        }
    },
    mounted(){
        const el = document.querySelector('.infinite-list')
        if(el){
            el.addEventListener('scroll', this.onScroll)
        }
    },
    methods: {
        onScroll() {
            const el = document.querySelector('.infinite-list')
            const overtakeOffset = 150
            this.blockScroll = false
            // scroll with simple throttle
            if (new Date().getTime() - this.nowThrottle > 100){
                // if edge of the screen is (almost) reached 
                // "almost" is set by overtakeOffset
                if (el.scrollTop + el.clientHeight + overtakeOffset >= el.scrollHeight && !this.blockScroll) {
                    this.blockScroll = true
                    this.$root.$emit('intiniteList')
                }
                this.nowThrottle = new Date().getTime(); // update simple throttle
            }
        }
    },
    destroy() {
        const el = document.querySelector('.infinite-list');
        el.removeEventListener('scroll', this.onScroll);
    }
}